export class SocketManager {
  constructor(socketInstance) {
    this.socket = socketInstance;
  }

  emitSocketEvent(event, data, callback = null) {
    if (!this.socket) {
      console.error('Socket is not initialized');
      return;
    }

    if (callback !== null) {
      this.socket.emit(event, data, callback);
    } else {
      this.socket.emit(event, data);
    }
  }

  onSocketEvent(event, callback) {
    if (this.socket) {
      this.socket.on(event, callback);
    } else {
      console.error('Socket is not initialized');
    }
  }

  offSocketEvent(event) {
    if (this.socket) {
      this.socket.off(event);
    } else {
      console.error('Socket is not initialized');
    }
  }
}
